export default __webpack_public_path__ + "static/media/loading.b793e9bc.svg";